import { render, staticRenderFns } from "./ProcessItem.vue?vue&type=template&id=7945d68c&scoped=true"
import script from "./ProcessItem.vue?vue&type=script&lang=js"
export * from "./ProcessItem.vue?vue&type=script&lang=js"
import style0 from "./ProcessItem.vue?vue&type=style&index=0&id=7945d68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7945d68c",
  null
  
)

export default component.exports